import React, { Fragment, useState, useEffect, useContext } from 'react';
import { ProjectContext } from '../../../../../context/Project';
import { Button } from 'reactstrap';
import useProjectSteps from '../../../../../hooks/useProjectSteps';
import { PixelContext } from '../../../../../context/Pixel';

function ContinueButton(props) {
    const projectSteps = useProjectSteps();
    const { projectTotalBudget, getArea, project } = useContext(ProjectContext);
    const { trackAnalyticsEvent, Events } = useContext(PixelContext);

    const [buttonEnabled, setButtonEnabled] = useState(false);

    useEffect(() => {
        setButtonEnabled(shouldEnableButton())
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [projectTotalBudget]);

    useEffect(() => {
        setButtonEnabled(shouldEnableButton());
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [project]);

    const shouldEnableButton = () => {
        return projectTotalBudget && projectTotalBudget > 0 && getArea();
    }

    return (
        <Fragment>
            {
                <Button disabled={!buttonEnabled}
                    onClick={() => {
						trackAnalyticsEvent(Events.ADD_ITEMS_CONTINUE_CLICK);
                        projectSteps.goNextStep();
                    }}
                    color="primary"
                    size="lg"
                    {...props}
                >
                    Continue
                </Button>
            }
        </Fragment>
    );
}

export default ContinueButton;